import React from 'react'

const PermissionsPage = React.lazy(() => import('pages/Permissions/PermissionsPage'));

const PermissionsRoutes = [
    {
        path: '/permissions',
        exact: true,
        name: 'Phân quyền',
        function: 'PERMISSION_VIEW',
        component: PermissionsPage,
    },
]

export default PermissionsRoutes
